<app-alerts />

<div class="bg-gray-50 p-12">
  <div class="mb-6 text-center">
    Wprowadź hasło, aby uzyskać dostęp do produktu.
  </div>

  <form [formGroup]="form">
    <app-form-control>
      <p-password
        [feedback]="false"
        [fluid]="true"
        [formControl]="form.controls.password"
        appPrimengPassword
        inputStyleClass="py-4" />
    </app-form-control>

    <div class="flex justify-end">
      <p-button
        (onClick)="handleSubmitClick()"
        [disabled]="form.invalid"
        appPrimengButton
        label="Prześlij"
        severity="primary"
        styleClass="py-3 px-6"
        type="submit" />
    </div>
  </form>
</div>
